var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomizeIncident(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8107 9.34068C11.7771 12.1057 9.50579 14.3312 6.74658 14.3312C3.95373 14.3312 1.68244 12.0551 1.68244 9.25638C1.68244 6.49136 3.92009 4.23214 6.66246 4.18156L8.15983 2.68104C7.70558 2.57988 7.23449 2.5293 6.72976 2.5293C3.02839 2.5293 0 5.54721 0 9.27324C0 12.9824 3.01157 16.0003 6.72976 16.0003C10.4311 16.0003 13.4595 12.9824 13.4595 9.27324C13.4595 8.7843 13.409 8.29537 13.3081 7.84015L11.8107 9.34068Z",
    fill: "#ACBED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6804 2.07376L13.9138 0.303477C13.51 -0.101159 12.7866 -0.101159 12.3828 0.303477L6.34285 6.3393C6.07366 6.60906 5.87177 6.94626 5.77082 7.31718L4.89595 10.5205C4.84548 10.6891 4.89595 10.8577 5.01372 10.9758C5.09785 11.0601 5.23244 11.1106 5.35021 11.1106C5.40069 11.1106 5.43433 11.1106 5.48481 11.0938L8.68144 10.2171C9.05158 10.1159 9.38807 9.91359 9.65726 9.64384L15.6804 3.60801C15.8823 3.40569 16.0001 3.13593 16.0001 2.84931C16.0001 2.54584 15.8823 2.27608 15.6804 2.07376ZM8.42908 9.30664L7.31867 9.61012C7.25137 9.39094 7.15042 9.18862 6.98218 9.02002C6.81394 8.86828 6.61204 8.76712 6.39333 8.68282L6.69616 7.57007C6.74664 7.38462 6.84758 7.19916 6.98218 7.04742C7.43644 7.19916 7.84022 7.45205 8.19354 7.78925C8.53002 8.12645 8.78239 8.54795 8.93381 9.00316C8.78239 9.1549 8.61415 9.25606 8.42908 9.30664Z",
    fill: "#ACBED2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeIncident);
export default __webpack_public_path__ + "static/media/CustomizeIncident.11fc018d473e7a258c1cf869feb79cbc.svg";
export { ForwardRef as ReactComponent };